// extracted by mini-css-extract-plugin
module.exports = {"iframe":"spinTheWheel-iframe-EMh","disabledRoot":"spinTheWheel-disabledRoot-Xy6","closeBtn":"spinTheWheel-closeBtn-uti","popupContent":"spinTheWheel-popupContent-F30"};